function CashSalaryIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<path
				fill="#8C8594"
				fillRule="evenodd"
				d="M2.04 13.98V6.42c0-.891.729-1.62 1.62-1.62h12.96c.891 0 1.62.729 1.62 1.62l-.009 7.56c0 .89-.72 1.62-1.61 1.62H3.66c-.891 0-1.62-.73-1.62-1.62zM6.165 6.6A2.325 2.325 0 013.84 8.925v.75l.075-.001v1.052l-.075-.001v.75A2.325 2.325 0 016.165 13.8h.75v-.075h6.45v.075h.75a2.325 2.325 0 012.325-2.325v-.75h-.075V9.675h.075v-.75A2.325 2.325 0 0114.115 6.6h-.75v.075h-6.45V6.6h-.75zm3.975 1.8a1.8 1.8 0 100 3.599 1.8 1.8 0 000-3.6zm-4.5 9.9a.9.9 0 01.9-.9h13.5V9.3a.9.9 0 111.8 0v8.1a1.8 1.8 0 01-1.8 1.8H6.54a.9.9 0 01-.9-.9z"
				clipRule="evenodd"
			/>
		</svg>
	);
}

export default CashSalaryIcon;
